export default __webpack_public_path__ + "static/media/sort_table_arrow.bbd6bd1d.svg";